import { render, staticRenderFns } from "./ListSections.vue?vue&type=template&id=904e33cc&scoped=true"
import script from "./ListSections.vue?vue&type=script&lang=js"
export * from "./ListSections.vue?vue&type=script&lang=js"
import style0 from "./ListSections.vue?vue&type=style&index=0&id=904e33cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904e33cc",
  null
  
)

export default component.exports